import React from 'react';
import PropTypes from 'prop-types';
import { startGuide, useDispatch } from '../../state';
import {usePages} from '../../hooks';
import {createStrictContext} from '../../state/_utils/createContext';
import {useNeuroMessages} from '../../components/MessageContext';

/**
 * @typedef LandingPageContextObject
 * @property {string} componentClass - the components class to use
 * @property {Boolean} isLoadingNextPage - true if next page is loading
 * @property {function(selectedPath)} onStartGuideClicked - function used to start the guide
 */

const createdContext = createStrictContext({
  name: 'LandingPageContext',
});
/** @type {LandingPageContextObject} */
const LandingPageContext = createdContext[0];
/** @returns {LandingPageContextObject} */
const useLandingPageContext = createdContext[1];

function LandingPageProvider({ Component }) {
  const dispatch = useDispatch();
  const { defaultPageTitle, isLoadingNextPage } = usePages();
  const { getMessage } = useNeuroMessages();
  const componentClass = 'landingPage';
  const onStartGuideClick = (selectedPath) => dispatch(startGuide(selectedPath || 'all'));

  //Update DOM title for Landing page
  const customPageTitleMsg = getMessage('landingPage.meta.title');
  document.title = customPageTitleMsg || defaultPageTitle;

  /** @type {LandingPageContextObject} */
  const contextValue = {
    componentClass,
    isLoadingNextPage,
    onStartGuideClick,
  };

  return (
    <LandingPageContext.Provider value={contextValue}>
      <Component {...contextValue} />
    </LandingPageContext.Provider>
  );
}

LandingPageProvider.propTypes = {
  Component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
};

export { useLandingPageContext };
export default LandingPageProvider;
